var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHomeRIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fill: "none",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "passthrough"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "passthrough"
    }
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 16,
    height: 16,
    rx: 0,
    fill: "#D8D8D8",
    fillOpacity: 0
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M3.75391,4.8873C3.75391,6.48191,5.04659,7.7746,6.64121,7.7746C8.23582,7.7746,9.52851,6.48191,9.52851,4.8873C9.52851,3.29269,8.23582,2,6.64121,2C5.04659,2,3.75391,3.29269,3.75391,4.8873ZM9.15998,6.86384C9.62103,6.32594,9.89897,5.62782,9.89897,4.86431C9.89897,4.496449999999999,9.83521,4.14494,9.71586,3.8212200000000003C9.67825,3.71658,9.72894,3.6005000000000003,9.8303,3.55309C10.11642,3.42066,10.43523,3.3503499999999997,10.77203,3.3536200000000003C11.9655,3.3667,12.9367,4.34276,12.9449,5.53627C12.953,6.75757,11.9655,7.74997,10.74587,7.74997C10.12623,7.74997,9.56544,7.49329,9.16652,7.07965C9.1093,7.01916,9.10602,6.92597,9.15998,6.86384ZM5.75604,7.93799L8.02533,7.93799C10.3306,7.93799,12.201,9.80836,12.201,12.1136L12.201,13.003C12.201,13.6259,11.6958,14.1311,11.0729,14.1311L2.43711,14.1311C1.644166,14.1311,1,13.487,1,12.694C1,10.06668,3.12869,7.93799,5.75604,7.93799ZM11.1409,8.1084L10.50658,8.1084C10.37742,8.1084,10.33,8.27843,10.44118,8.34546C11.705,9.0959,12.5519,10.47415,12.5519,12.0519L12.5519,12.9691C12.5519,13.2159,12.475,13.4448,12.3426,13.6345C12.2838,13.7179,12.3426,13.834,12.4456,13.834L13.9563,13.834C14.5318,13.834,14.9994,13.3664,14.9994,12.7909L14.9994,11.97012C14.9994,9.83653,13.2713,8.1084,11.1409,8.1084Z",
    fillRule: "evenodd",
    fill: "#4163FE",
    fillOpacity: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeRIcon);
export default __webpack_public_path__ + "static/media/home_r_icon.246f04fbffb5e9cf6f9285f9e96087ba.svg";
export { ForwardRef as ReactComponent };